import { render, staticRenderFns } from "./ticketPrice.vue?vue&type=template&id=5495a3a9"
import script from "./ticketPrice.vue?vue&type=script&lang=js"
export * from "./ticketPrice.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports